import React from 'react';
import { connect } from 'react-redux';
import { mediaPickerActions } from '../../../store';
import StockOrientationSelect from '../../../common/StockOrientationSelect';

const BackgroundVideosOrientationSelect = (props) => {
    const {
        onOrientationChange,
        setBackgroundStockVideosOrientation,
        backgroundStockVideosOrientation
    } = props;

    return (
        <StockOrientationSelect
            onOrientationChange={onOrientationChange}
            mediaOrientation={backgroundStockVideosOrientation}
            setStockMediaOrientation={setBackgroundStockVideosOrientation}
        />
    );
};

const mapStateToProps = (state) => {
    const {
        backgroundStockVideosOrientation
    } = state.mediaPicker;

    return {
        backgroundStockVideosOrientation
    };
}

const mapDispatchToProps = (dispatch) => {
    const setBackgroundStockVideosOrientation = (orientation) => dispatch(mediaPickerActions.setBackgroundStockVideosOrientation(orientation));

    return {
        setBackgroundStockVideosOrientation
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackgroundVideosOrientationSelect);